// Ops toggle: let the advertised (local) crew win its own bookings at
// window close unless another local crew bid lower. Meaningless for the
// house crew (no other bidder to lose to) and refused server-side for the
// Avis supplier (not a crew) — so the field renders for neither.
import { BooleanField } from '@/components/forms';
import type { AdminVendorDetail } from '@/lib/admin-api';

export function VendorAutoAssignField({
  vendor,
  checked,
  onChange,
}: {
  vendor: AdminVendorDetail;
  checked: boolean;
  onChange: (v: boolean) => void;
}) {
  if (vendor.isHouse || vendor.source === 'avis') return null;

  return (
    <BooleanField
      label="Auto-assign advertised bookings"
      hint="This crew is not invited to bid on its own listings. At window close it wins at its advertised price unless another local crew bid lower. Local crews only. In manual dispatch mode a lower bid still goes to ops; without one the crew is assigned automatically."
      checked={checked}
      onChange={onChange}
    />
  );
}
